/*
 * Accordion motion — animates every <details class="accordion__item">.
 * Opening eases the panel's height open and cascades its lines in; closing
 * eases it shut before the element actually closes. A click mid-animation
 * reverses from wherever the panel is. With prefers-reduced-motion, or on an
 * engine without the Web Animations API, <details> keeps its instant toggle.
 */
(function () {
  if (window.__trochiAccordionMotion) return;
  window.__trochiAccordionMotion = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!Element.prototype.animate) return;

  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var OPEN_MS = 520;
  var CLOSE_MS = 360;
  var LINE_SELECTOR = 'li, p, dt, dd, tr, h3, h4';
  var MAX_LINES = 16;

  function lines(content) {
    var found = content.querySelectorAll(LINE_SELECTOR);
    var list = [];
    for (var i = 0; i < found.length && list.length < MAX_LINES; i++) {
      // A <p> inside an <li> would double-animate; take the outermost match only
      var parent = found[i].parentElement.closest(LINE_SELECTOR);
      if (!parent || !content.contains(parent)) list.push(found[i]);
    }
    return list.length ? list : Array.prototype.slice.call(content.children, 0, MAX_LINES);
  }

  // onfinish never fires in a hidden tab (no frames), so a timer settles the
  // element too; whichever comes first wins and the other is a no-op.
  function settle(details, anim, ms, done) {
    var fired = false;
    function run() {
      if (fired || details._accAnim !== anim) return;
      fired = true;
      anim.cancel();
      done();
    }
    anim.onfinish = run;
    setTimeout(run, ms + 80);
  }

  // Padding is animated with the height, otherwise a border-box panel can
  // not shrink below its own padding and snaps shut from there.
  function padding(content) {
    var cs = getComputedStyle(content);
    return { top: cs.paddingTop, bottom: cs.paddingBottom };
  }

  function finish(details) {
    var content = details._accContent;
    content.style.height = '';
    content.style.overflow = '';
    details.classList.remove('is-opening', 'is-closing');
    details._accAnim = null;
  }

  function open(details, content) {
    var start = details._accAnim ? content.getBoundingClientRect().height : 0;
    if (details._accAnim) details._accAnim.cancel();
    details.open = true;
    details.classList.remove('is-closing');
    details.classList.add('is-opening');
    var end = content.scrollHeight;
    var pad = padding(content);
    content.style.overflow = 'hidden';

    var anim = content.animate(
      [
        { height: start + 'px', paddingTop: start ? pad.top : '0px', paddingBottom: start ? pad.bottom : '0px', opacity: start ? 1 : 0.2 },
        { height: end + 'px', paddingTop: pad.top, paddingBottom: pad.bottom, opacity: 1 }
      ],
      { duration: OPEN_MS, easing: EASE }
    );
    details._accAnim = anim;
    settle(details, anim, OPEN_MS, function () { finish(details); });

    if (!start) {
      lines(content).forEach(function (line, i) {
        line.animate(
          [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }],
          { duration: 420, delay: 60 + i * 40, easing: EASE, fill: 'backwards' }
        );
      });
    }
  }

  function close(details, content) {
    var start = content.getBoundingClientRect().height;
    if (details._accAnim) details._accAnim.cancel();
    var pad = padding(content);
    details.classList.remove('is-opening');
    details.classList.add('is-closing');
    content.style.overflow = 'hidden';

    var anim = content.animate(
      [
        { height: start + 'px', paddingTop: pad.top, paddingBottom: pad.bottom, opacity: 1 },
        { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 }
      ],
      { duration: CLOSE_MS, easing: EASE }
    );
    details._accAnim = anim;
    settle(details, anim, CLOSE_MS, function () {
      details.open = false;
      finish(details);
    });
  }

  document.addEventListener('click', function (e) {
    if (reduced.matches) return;
    var summary = e.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.classList.contains('accordion__item')) return;
    var content = details.querySelector(':scope > .accordion__content');
    if (!content) return;

    e.preventDefault();
    details._accContent = content;
    var closing = details.classList.contains('is-closing');
    if (details.open && !closing) close(details, content);
    else open(details, content);
  });
})();
